import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import {
  ArrowLeft,
  ListDashes,
  X
} from '@phosphor-icons/react';
const PublicNavHeader = ({ showBack = true }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { user, authStatus } = useAuth();
  const isAuthenticated = authStatus === 'authenticated' && user;
  
  // Map current public page to appropriate authenticated page
  // Note: Command is a FAB feature available everywhere, not a dedicated page
  const getTargetPage = () => {
    const path = location.pathname;
    switch (path) {
      case '/ai-agents':
        return '/partner-pro/ai-workforce/marketplace-v2';
      case '/command':
        return '/dashboard';
      case '/create-agent':
        return '/partner-pro/ai-workforce/agents/create';
      case '/security':
        return '/dashboard';
      default:
        return '/dashboard';
    }
  };

  const navLinks = [
    { to: '/ai-agents', label: 'Workers' },
    { to: '/command', label: 'Command' },
    { to: '/create-agent', label: 'Create a Worker' },
    { to: '/how-we-score', label: 'How We Score' },
    { to: '/security', label: 'Security' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-[#0a0a0f]/80 backdrop-blur-xl border-b border-[rgba(255,255,255,0.05)]">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-10 h-10 bg-transparent rounded-lg flex items-center justify-center overflow-visible">
              <img 
                src="/man-and-machine-logo.png" 
                alt="Man & Machine Logo" 
                className="w-14 h-14 object-contain"
              />
            </div>
            <div className="flex flex-col">
              <span className="text-lg font-bold tracking-tight" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                <span className="text-white">MAN</span>
                <span className="text-[#00E5C0] mx-1">&</span>
                <span className="text-white">MACHINE</span>
              </span>
            </div>
          </Link>

          {/* Desktop Navigation - SEO Sitelinks */}
          <nav aria-label="Main navigation" className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-[#A0AEC0] hover:text-white text-sm font-medium transition-colors"
              >
                {link.label}
              </Link>
            ))}
            {/* Show "Go to App" for authenticated users, "Sign In" for guests */}
            {isAuthenticated ? (
              <Link
                to={getTargetPage()}
                className="px-4 py-2 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity"
              >
                Go to App
              </Link>
            ) : (
              <Link
                to={`/login?redirect=${encodeURIComponent(getTargetPage())}`}
                className="px-4 py-2 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity"
              >
                Sign In
              </Link>
            )}
          </nav>

          {/* Mobile ListDashes Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X size={24} /> : <ListDashes size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav aria-label="Mobile navigation" className="md:hidden mt-4 pb-4 border-t border-[rgba(255,255,255,0.1)] pt-4">
            <div className="flex flex-col gap-3">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileMenuOpen(false)}
                  className="text-[#A0AEC0] hover:text-white text-sm font-medium transition-colors py-2"
                >
                  {link.label}
                </Link>
              ))}
              {/* Show "Go to App" for authenticated users, "Sign In" for guests */}
              {isAuthenticated ? (
                <Link
                  to={getTargetPage()}
                  onClick={() => setMobileMenuOpen(false)}
                  className="mt-2 px-4 py-2 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity text-center"
                >
                  Go to App
                </Link>
              ) : (
                <Link
                  to={`/login?redirect=${encodeURIComponent(getTargetPage())}`}
                  onClick={() => setMobileMenuOpen(false)}
                  className="mt-2 px-4 py-2 bg-gradient-to-r from-[#6366F1] to-[#8B5CF6] text-white text-sm font-medium rounded-lg hover:opacity-90 transition-opacity text-center"
                >
                  Sign In
                </Link>
              )}
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default PublicNavHeader;
